import { Base } from '@core/base/base'
import mixpanel from 'mixpanel-browser'

export const Analytics = new (class Analytics extends Base {
    constructor() {
        super('mixpanel.service')
        this.listenToEvents()
    }

    listenToEvents() {
        this.$eventBus.on('app_initialized', ({ user, account, accounts }) => {
            if (!this.isEnabled) return

            this.identify(user.id, {
                $name: `${user.first_name || 'N/A'} ${user.last_name || 'N/A'}`,
                $first_name: user.first_name || 'N/A',
                $last_name: user.last_name || 'N/A',
                $email: user.email?.value,
                user_agent: window.navigator.userAgent,
            })

            mixpanel.register({
                account_id: account,
                company_id: accounts[account]?.company_id,
                user_email: user.email?.value,
            })

            this.event('SEM::app_initialized')
        })

        this.$eventBus.on('fs_set_user_vars', (args) => {
            this.isEnabled && this.setUserVars(args)
        })
    }

    get isEnabled() {
        return (
            !import.meta.env.DEV &&
            this.envVars.REACT_APP_MIXPANEL_ON === 'true' &&
            this.envVars.REACT_APP_MIXPANEL_TOKEN
        )
    }

    init() {
        if (this.isEnabled) {
            // @ts-ignore
            const mixpanelConfig = {
                track_pageview: true,
                persistence: 'localStorage',
                api_host: 'https://mixpanel.at-bay.com',
                autocapture: {
                    pageview: 'full-url',
                    click: true,
                    input: true,
                    scroll: true,
                    submit: true,
                    capture_text_content: true,
                },
                ignore_dnt: true,
                record_sessions_percent: 100,
                record_mask_text_selector: '',
            }

            // @ts-ignore
            mixpanel.init(this.envVars.REACT_APP_MIXPANEL_TOKEN, mixpanelConfig)
        }
    }

    identify(uid: string, args: { [key: string]: unknown }) {
        if (this.isEnabled) {
            if (uid) {
                mixpanel.identify(uid)
                mixpanel.people.set(args)
            } else {
                mixpanel.reset()
            }
        }
    }

    event(name: AnalyticsEvents, args?: { [key: string]: unknown }) {
        this.isEnabled &&
            mixpanel.track(name, { ...args, ...this.now } as {
                [key: string]: unknown
            })
    }

    get now() {
        return { ts: new Date().toISOString() }
    }

    setUserVars<T extends object>(args: T) {
        this.isEnabled && mixpanel.people.set(args)
    }
})()
